import {defaultNotificationState} from "./notification.initial-state";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {IMessage} from "./notification.types";
import {addNotificationToQueue, removeNotificationFromQueue} from "./notification.operations";

export const notificationSlice = createSlice({
  initialState: defaultNotificationState,
  name: 'notification',
  reducers: {
    clearNotificationState() {
      return defaultNotificationState;
    },
    removeNotification(state, { payload }: PayloadAction<IMessage>) {
      state.messages = removeNotificationFromQueue(payload, state.messages);
    },
    showNotification(state, { payload }: PayloadAction<IMessage>) {
      state.messages = addNotificationToQueue(payload, state.messages);
    },
    updateNotification(state, { payload }: PayloadAction<IMessage>) {
      if (!payload.id) {
        return;
      }
      const index = state.messages.findIndex((item) => item.id === payload.id);
      if (index >= 0) {
        state.messages[index] = {
          ...state.messages[index],
          ...payload,
          summary: payload.summary ?? state.messages[index].summary,
        };
      } else {
        state.messages = addNotificationToQueue(payload, state.messages);
      }
    },
    showLoadingNotification(state, { payload }: PayloadAction<IMessage>) {
      state.loadingMessages = addNotificationToQueue(payload, state.loadingMessages);
    },
    removeLoadingNotification(state, { payload }: PayloadAction<IMessage>) {
      state.loadingMessages = removeNotificationFromQueue(payload, state.loadingMessages);
    },
  },
  // eslint-disable-next-line sort-keys
  extraReducers: (builder) => {
  },
});

export const {
  clearNotificationState,
  removeNotification,
  showNotification,
  updateNotification,
  showLoadingNotification,
  removeLoadingNotification,
} = notificationSlice.actions;

export default notificationSlice.reducer;
